document.addEventListener("DOMContentLoaded", function () {

  const banners = document.querySelectorAll(".homepage-banner");

  banners.forEach((banner) => {

    const slider = banner.querySelector(".homepage-banner__slider");
    const slides = banner.querySelectorAll(".homepage-banner__slide");
    const prev = banner.querySelector(".homepage-banner__prev");
    const next = banner.querySelector(".homepage-banner__next");
    const dotsContainer = banner.querySelector(".homepage-banner__dots");

    if (!slider || slides.length === 0) return;

    let current = 0;
    let autoSlide;

    /* ----------------------------
       Create Pagination Dots
    -----------------------------*/

    slides.forEach((slide, index) => {

      const dot = document.createElement("span");

      dot.classList.add("homepage-banner__dot");

      if (index === 0) {
        dot.classList.add("active");
      }

      dot.addEventListener("click", () => {
        current = index;
        updateSlider();
        restartAutoplay();
      });

      dotsContainer.appendChild(dot);

    });

    const dots = banner.querySelectorAll(".homepage-banner__dot");

    /* ----------------------------
       Update Slider
    -----------------------------*/

    function updateSlider() {

      slider.style.transform = `translateX(-${current * 100}%)`;

      dots.forEach(dot => dot.classList.remove("active"));

      dots[current].classList.add("active");

    }

    /* ----------------------------
       Next Slide
    -----------------------------*/

    function nextSlide() {

      current++;

      if (current >= slides.length) {
        current = 0;
      }

      updateSlider();

    }

    /* ----------------------------
       Previous Slide
    -----------------------------*/

    function prevSlide() {

      current--;

      if (current < 0) {
        current = slides.length - 1;
      }

      updateSlider();

    }

    /* ----------------------------
       Buttons
    -----------------------------*/

    next.addEventListener("click", () => {
      nextSlide();
      restartAutoplay();
    });

    prev.addEventListener("click", () => {
      prevSlide();
      restartAutoplay();
    });

    /* ----------------------------
       Autoplay
    -----------------------------*/

    function startAutoplay() {

      autoSlide = setInterval(() => {

        nextSlide();

      }, 4000);

    }

    function stopAutoplay() {

      clearInterval(autoSlide);

    }

    function restartAutoplay() {

      stopAutoplay();

      startAutoplay();

    }

    banner.addEventListener("mouseenter", stopAutoplay);

    banner.addEventListener("mouseleave", startAutoplay);

    /* ----------------------------
       Swipe Support
    -----------------------------*/

    let touchStartX = 0;
    let touchEndX = 0;

    slider.addEventListener("touchstart", (e) => {

      touchStartX = e.changedTouches[0].screenX;

    });

    slider.addEventListener("touchend", (e) => {

      touchEndX = e.changedTouches[0].screenX;

      if (touchStartX - touchEndX > 50) {

        nextSlide();

      }

      if (touchEndX - touchStartX > 50) {

        prevSlide();

      }

      restartAutoplay();

    });

    /* ----------------------------
       Start
    -----------------------------*/

    updateSlider();

    startAutoplay();

  });

});